import React from 'react';
 import "react-daterange-picker/dist/css/react-calendar.css";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import PieChart from "./charts/pieChart"
import { connect } from "react-redux";
import BarChart from './charts/barChart';
import { NavLink, withRouter } from "react-router-dom";
import {getRequestStatusList, getMonthlyRequestList} from "../../services/admin/action";

const moment = extendMoment(originalMoment);

class RequestCharts extends React.Component {
    constructor(props) {
        super(props);

        const today = moment();

        this.state = {
            isOpen: false,
            dateRange: moment.range(today.clone().subtract(1, "month"), today.clone()),
            facilityName:"",
            practitionerName:"",
            userName:"",
            requestStatus:"",
            barStatus :false,
            barChartValues:[]
             
        };
    }
    onSelect = (value) => {
        this.setState({ dateRange:value, isOpen : false  });
      };

    onToggle = (e) => {
        e.preventDefault();
    this.setState({ isOpen: !this.state.isOpen });
    };

    handleChange = (e) => {
        e.preventDefault();
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value });
    };

    componentDidMount(){
        let access_token = this.props.loginDetails;
        this.searchReports();
        this.props.getMonthlyRequestList(access_token);
    }
 
    renderSelectionValue = () => {
   
        return (
          <div>
             {this.state.dateRange.start.format("YYYY-MM-DD")}
            {" - "}
            {this.state.dateRange.end.format("YYYY-MM-DD")}
          </div>
        );
      };
     

      searchReports =() =>{
        //  const{ dateRange,  } = this.state;

        //   let fromDate =  dateRange.start.format("YYYY-MM-DD")
        //   let toDate =   dateRange.end.format("YYYY-MM-DD")
          let access_token = this.props.loginDetails;

          let payload = {
            requestStatus:"",
            facilityName:"",
            practitionerName:"",
            userName:"",
            fromDate:"",
            toDate:"",
          }
          this.props.getRequestStatusList(access_token, payload)
         

      }

      componentWillReceiveProps = nextProps => {
 
    if( nextProps.getMonthlyRequestStatus){
        if(nextProps.getMonthlyRequestListDetails){

         let  barData =  nextProps.getMonthlyRequestListDetails.monthlyWiseReport;
          let barOne = barData[0].countCurrentMonth;
         let barTwo = barData[0].countLastMonth;
         let barThree = barData[0].countlastBeforeMonth;

         let  barChartValues = [ barThree, barTwo, barOne, ]

          let barStatus ;
         if(barOne === 0 && barTwo === 0 && barThree === 0){
             barStatus = false
         }else{
             barStatus = true
         }
         this.setState({
            barChartValues,
            barStatus
         })
        }
    }
    };

    teamNav = () =>{
        this.props.history.push("/Settings", {pageName : "employeePage"})
    }


    render() {
      
      //  const {facilityName, practitionerName, userName, requestStatus} = this.state;
        // let startDate = this.state.dateRange.start.format("YYYY-MM-DD")
        // let endDate =  this.state.dateRange.end.format("YYYY-MM-DD")

        let pieStatus ;
        let one ;
        let two ;
        let three; 
    if(this.props.getRequestStatusListDetails){
            let data = this.props.getRequestStatusListDetails.requestStatusDTO;
                  one = data.CompletedStatusCount;
                 two = data.RequestedStatusCount;
                three = data.pendingStatusCount;
       
        
                if(one === 0 && two === 0 && three === 0){
                    pieStatus = false
                }else{
                    pieStatus = true
                }
            }
   
       
        return (
            <React.Fragment>
                <div className="row">
            
                    <div class="col-lg-12">
                
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <div className="chartDetails">
                            <h4><img alt="" src="images/request.png" /> Requests by status </h4>
                            <div className="chartContent">
                            {pieStatus &&
                                 <PieChart one={one} two={two} three={three} /> 
                            }
                             {!pieStatus &&
                               <div className="no-data-chart"> <img alt="" src="images/no-data-chart.png"/></div>  }
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <div className="chartDetails">
                            <h4><img alt="" src="images/request.png" /> Requests</h4>
                            <div className="chartContent">
                                <BarChart barChartValues ={this.state.barChartValues} />
                             </div>  
                        </div>
                    </div>
                    </div>
                    
                </div>

                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 marginTop20 text-center">
                        
                        <NavLink to="/PaymentRules"   >      <button type="button"  className="btnDefault">Payment Rules</button></NavLink>
                        
                        <NavLink   to={{ pathname: '/Settings', state: { page: 'EmployeePage'} }}   > <button type="button" onClick={this.teamNav} className="btnDefault">Team Members</button></NavLink>
                    </div>
                </div>



                {/* Add Employee */}



            </React.Fragment>
        )
    }
}

 
 

const mapStateToProps = state => ({
    loginDetails: state.commonReducer.loginDetails,
    profileDetails: state.commonReducer.profileDetails,
    getRequestStatusListStatus : state.adminReducer.getRequestStatusListStatus,
    getRequestStatusListDetails : state.adminReducer.getRequestStatusListDetails,
    getMonthlyRequestListDetails : state.adminReducer.getMonthlyRequestListDetails,
    getMonthlyRequestStatus : state.adminReducer.getMonthlyRequestStatus

  });
  
  const mapDispatchToProps = dispatch => ({
    getRequestStatusList: (token, payload) => dispatch(getRequestStatusList(token, payload)),
    getMonthlyRequestList: (token) => dispatch(getMonthlyRequestList(token)),

   });
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(RequestCharts));

 